import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BsX } from "react-icons/bs";

import {
  Modal as NextUIModal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
} from "@nextui-org/react";

const Modal = ({
  isOpen = false,
  modalHeaderComponent = null,
  children,
  handleOnClose = () => {},
  handleOnConfirm = () => {},
  handleOnOpenChange = () => {},
  showFooter = true,
  size = "2xl",
  radius = "lg",
  className = "",
  displayCloseButton = true,
}) => {
  const { t } = useTranslation();
  const { onClose } = useDisclosure();

  const handleClose = () => {
    onClose();
    handleOnClose();
  };

  const handleConfirm = () => {
    onClose();
    handleOnClose();
    handleOnConfirm();
  };

  const modalClassNames = {
    closeButton: "hidden",
    base: size === "full" ? "max-w-[1400px] w-[95vw] h-[80vh] max-h-[800px] !rounded-2xl" : "",
    wrapper: size === "full" ? "overflow-hidden items-center justify-center" : "",
    body: size === "full" ? "p-0 overflow-hidden h-full !rounded-2xl" : "",
  };

  return (
    <NextUIModal
      isOpen={isOpen}
      onOpenChange={handleOnOpenChange}
      onClose={() => handleClose()}
      size={size}
      radius={radius}
      classNames={modalClassNames}
      className={className}
    >
      <ModalContent className={size === "full" ? "h-full overflow-hidden !rounded-2xl" : ""}>
        {displayCloseButton && (
          <div
            className="z-50 cursor-pointer absolute flex items-center top-[8px] right-[8px] rounded-full bg-[#111111]/[.6]"
            onClick={handleClose}
            onKeyDown={handleClose}
          >
            <BsX
              className="text-white"
              size={18}
            />
          </div>
        )}
        {modalHeaderComponent && <ModalHeader className="p-0">{modalHeaderComponent}</ModalHeader>}
        <ModalBody className={`p-0 ${size === "full" ? "h-full overflow-hidden" : ""}`}>
          {children}
        </ModalBody>
        {showFooter && (
          <ModalFooter>
            <Button
              color="danger"
              variant="light"
              onPress={handleClose}
            >
              {t("Close")}
            </Button>
            <Button
              color="primary"
              onPress={handleConfirm}
            >
              {t("Confirm")}
            </Button>
          </ModalFooter>
        )}
      </ModalContent>
    </NextUIModal>
  );
};

export default Modal;
